export default __webpack_public_path__ + "static/automated-process-03706835e54aaba72a1b2031b8b85c40.png";